import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import AOS from "aos";
import "aos/dist/aos.css";

const BlogSidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [tagsList, setTagsList] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  useEffect(() => {
    axiosInstance
      .get("/api/v1/users/articles/side-menu")
      .then((response) => {
        const fetchedArticles = response.data.articles || [];

        // إزالة المقالات المكررة بناءً على الـ ID
        const uniqueArticles = fetchedArticles.filter(
          (article, index, self) =>
            index === self.findIndex((t) => t.id === article.id)
        );

        setArticles(uniqueArticles);
        setFilteredArticles(uniqueArticles);
        setTagsList(response.data.tags || []);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  useEffect(() => {
    const filtered = articles.filter((article) =>
      article.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredArticles(filtered);
  }, [searchQuery, articles]);

  const handleArticleClick = (articleId) => {
    navigate(`/article/${articleId}`);
  };

  return (
    <div className="col-lg-4">
      {/* Search Bar */}
      <div className="card shadow-sm mb-4" data-aos="fade-up">
        <div className="card-body">
          <h3 className="h5 fw-bold mb-3">{t("Search")}</h3>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder={t("search_blogs")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="btn btn-primary" type="button">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Popular Posts */}
      <div className="card shadow-sm mb-4" data-aos="fade-up">
        <div className="card-body">
          <h3 className="h5 fw-bold mb-3">{t("popular_articles")}</h3>
          {filteredArticles.length > 0 ? (
            filteredArticles.map((post, index) => (
              <div
                key={post.id}
                className={`d-flex ${
                  index !== filteredArticles.length - 1
                    ? "mb-3 pb-3 border-bottom"
                    : ""
                }`}
                role="button"
                onClick={() => handleArticleClick(post.id)}
              >
                <div
                  className="flex-shrink-0"
                  style={{ width: "70px", height: "70px", overflow: "hidden" }}
                >
                  <img
                    src={
                      post.thumbnailImagePath 
                    }
                    alt={post.englishTitle}
                    className="img-fluid rounded"
                    style={{
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="flex-grow-1 ms-3">
                  <h6 className="fw-bold mb-1">{post.englishTitle}</h6>
                  <small className="text-muted">{post.createdOn || ""}</small>
                </div>
              </div>
            ))
          ) : (
            <p>{t("no_articles_found")}</p>
          )}
        </div>
      </div>

      {/* Tags */}
      {tagsList.length > 0 && (
        <div className="card shadow-sm mb-4" data-aos="fade-up">
          <div className="card-body">
            <h3 className="h5 fw-bold mb-3">{t("tags")}</h3>
            <div className="d-flex flex-wrap gap-2">
              {tagsList.map((tag, i) => (
                <a
                  key={i}
                  href={tag.link || "#"} 
                  className="badge bg-light text-dark text-decoration-none p-2"
                >
                  {tag.name} {/* عرض اسم التاج */}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default BlogSidebar;
